import { service } from '@/utils/request'

export default {
  // 查询
  getList(pageIndex, pageSize, data) {
    return service({
      url: `/cloud/uac/vipCard/pages?pageIndex=${pageIndex}&pageSize=${pageSize}`,
      method: 'post',
      data
    })
  },
  // 创建 / 编辑
  save(data) {
    return service({
      url: '/cloud/uac/vipCard/save',
      method: 'post',
      data: data
    })
  },
  // 修改状态
  changeStatus(data) {
    return service({
      url: '/cloud/uac/vipCard/status',
      method: 'post',
      data: data
    })
  },
  // 详情
  detail(id) {
    return service({
      url: '/cloud/uac/vipCard/detail/' + id,
      method: 'get'
    })
  },
  // 删除
  delete(id) {
    return service({
      url: '/cloud/uac/vipCard/del/' + id,
      method: 'get'
    })
  },
  // 查询所有卡片
  getAllCard() {
    return service({
      url: '/cloud/uac/vipCard/allCard',
      method: 'get'
    })
  },
  // 查询卡种列表
  getCardType() {
    return service({
      url: '/cloud/uac/vipCard/cardTypeList',
      method: 'get'
    })
  },
  // 修改权益
  changeUpdEquity(data) {
    return service({
      url: '/cloud/uac/vipCard/updEquity',
      method: 'post',
      data
    })
  },
  // 修改权益
  changeOpen(params) {
    return service({
      url: '/cloud/uac/vipCard/changeOpen?' + params,
      method: 'post'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/operateManage/vipCard.js